import React, { useCallback, useEffect, useRef, useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import Overview from "../../assets/svg/Overview.svg";
import Calander from "../../assets/svg/Calander.svg";
import Meter from "../../assets/svg/Dash_Meter.svg";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as DefaultProIc } from "../../assets/svg/default_pro.svg";
import { Bar, Doughnut } from "react-chartjs-2";
import YearPicker from "../common/yearpicker";
import MonthPicker from "../common/monthpicker";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement, // ⭐ Required for Doughnut
  Tooltip,
  Legend,
} from "chart.js";

//Api Import
import { getActivityApi, getConsumptionApi, getCountsApi, getCurrentValueApi, getDailyprograssApi, getDeprecitTotalApi, getEmployeeApi, getGatelogApi, getMonthTotalApi, getTlusageApi, getyearTotalApi } from "./dashboard-api";
import ReactPaginate from "react-paginate";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import "./toggle-swtich.css";
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ArcElement);

const Dashboard = () => {
  const [activeInvIndex, setActiveInvIndex] = useState(11);
  const [monthListValue, setMonthListValue] = useState([]);
  const [deprecitionListValue, setdeprictionListValue] = useState([]);
  // bar value
  const [isMonthly, setIsMonthly] = useState(true);
  const [selectedYearTotal, setSelectedYearTotal] = useState(new Date());
  const [selectedYearMontTotal, setSelectedYearMontTotal] = useState(new Date());
  const [selectedDeprecYear, setSelectedDeprecYear] = useState(new Date());
  const [selectedMonth, setSelectedMonth] = useState(new Date());

  const [currentValueTotal, setCurrentValueTotal] = useState(0);
  const [currentValueData, setCurrentValueData] = useState([]);

  const [counts, setcounts] = useState({});
  const [filtervalue, setfilterValue] = useState("");
  const [consumptionDate, setConsumptiondate] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });
  const [consumption, setConsumption] = useState([]);
  const totalReading = consumption.reduce((sum, item) => sum + item.reading, 0);
  const [activeExpIndex, setActiveExpIndex] = useState(0);
  const [activityDate, setActivitydate] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });
  const [activity, setActivity] = useState({});
  //daily progress
  const [progressData, setProgressData] = useState({
    checkout: 0,
    checkin: 0,
    approved: 0,
    report: 0,
  });
  const [total, setTotal] = useState(0);
  const { checkout, checkin, approved, report } = progressData;
  const [employeesData, setEmployeesData] = useState([]);
  const [search, setSearch] = useState("");
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [employeeCount, setEmployeeCount] = useState(0);

  const chartRef = useRef(null);
  const [dailyprocess, setDailyprocess] = useState(() => new Date().toISOString().split("T")[0]);

  const [topdate, setTopdate] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });
  const [tlusage, setTlusage] = useState({});
  //Gatelog activity
  const [gatelogDate, setGatelogdate] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });

  const [gatelog, setGatelog] = useState({});
  const [labels, setLabels] = useState([]);
  const [checkInData, setCheckInData] = useState([]);
  const [checkOutData, setCheckOutData] = useState([]);
  const [assetStatusData, setAssetStatusData] = useState([]);
  const barColors = ["#3B84E6", "#579CF7", "#80B7FF", "#9FC9FF", "#C4DDFF"];
  // const assetStatusData = [
  //   { name: "Allocated", amount: 320 },
  //   { name: "Unallocated", amount: 150 },
  //   { name: "Scrap", amount: 45 },
  //   { name: "Repair", amount: 28 },
  //   { name: "Missing", amount: 12 },
  // ];

  const monthNames = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December",
  };

  const externalTooltipHandler = (context) => {
    const { chart, tooltip } = context;

    let tooltipEl = document.getElementById("custom-chart-tooltip");

    // Create tooltip element if not found
    if (!tooltipEl) {
      tooltipEl = document.createElement("div");
      tooltipEl.id = "custom-chart-tooltip";
      tooltipEl.style.position = "absolute";
      tooltipEl.style.pointerEvents = "none";
      tooltipEl.style.background = "#FFFFFF";
      tooltipEl.style.borderRadius = "12px";
      tooltipEl.style.padding = "14px 16px";
      tooltipEl.style.boxShadow = "0 4px 20px rgba(0,0,0,0.15)";
      tooltipEl.style.opacity = 0;
      tooltipEl.style.transition = "opacity 0.15s ease";
      tooltipEl.style.zIndex = 99999;

      document.body.appendChild(tooltipEl);
    }

    // Hide tooltip when mouse leaves
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }

    const dp = tooltip.dataPoints[0];
    const index = dp.dataIndex;
    const value = dp.raw;
    const month = dp.label;

    // Access month wise full record
    const monthRecord = monthListValue[index];

    const statusHtml = monthRecord.status
      .map(
        (s) => `
        <div style="display:flex;justify-content:space-between;margin:2px 0;font-size:13px;">
          <span style="text-transform:capitalize;color:#4D4D4D">${s.name}</span>
           <span>
          <span style="color:#212129;font-weight:600;">₹${s.cost.toLocaleString("en-IN")}</span>
          <span style="color:#3B84E6;font-weight:600;margin-left:6px;">• ${s.count}</span>
        </span>
        </div>
      `,
      )
      .join("");

    tooltipEl.innerHTML = `
    <div style="font-size:12px;color:#3B84E6;margin-bottom:6px;">   ${monthNames[month]} ${selectedYearMontTotal?.getFullYear()}</div>
   
    ${statusHtml}
  `;

    tooltipEl.style.width = "240px";

    // Calculate safe positions
    const { left, top } = chart.canvas.getBoundingClientRect();
    const tooltipHeight = tooltipEl.offsetHeight;
    const tooltipWidth = tooltipEl.offsetWidth;

    let tooltipX = left + tooltip.caretX - tooltipWidth / 2;
    let tooltipY = top + tooltip.caretY - tooltipHeight - 15; // default above

    // Push down if too high
    if (tooltipY < 10) {
      tooltipY = top + tooltip.caretY + 15;
    }

    // Prevent overflow bottom
    if (tooltipY + tooltipHeight > window.innerHeight) {
      tooltipY = window.innerHeight - tooltipHeight - 10;
    }

    // Prevent overflow right
    if (tooltipX + tooltipWidth > window.innerWidth) {
      tooltipX = window.innerWidth - tooltipWidth - 10;
    }

    // Prevent overflow left
    if (tooltipX < 10) {
      tooltipX = 10;
    }

    tooltipEl.style.left = tooltipX + "px";
    tooltipEl.style.top = tooltipY + "px";
    tooltipEl.style.opacity = 1;
  };

  const barValuePlugin = {
    id: "barValuePlugin",
    afterDatasetsDraw(chart) {
      const { ctx } = chart;

      chart.data.datasets.forEach((dataset, datasetIndex) => {
        const meta = chart.getDatasetMeta(datasetIndex);

        meta.data.forEach((bar, index) => {
          const value = dataset.data[index];
          const count = assetStatusData[index]?.count ?? 0;
          // ⭐ Count value

          const amount = `₹ ${value.toLocaleString("en-IN")}`;

          const x = bar.x + 10;
          const y = bar.y;

          ctx.save();

          // ₹ Amount
          ctx.fillStyle = "#0E1A35"; // dark blue
          ctx.font = "600 13x";
          ctx.textBaseline = "middle";
          ctx.textAlign = "left";
          ctx.fillText(amount, x, y);

          // Dot separator
          const dotX = x + ctx.measureText(amount).width + 12;
          ctx.beginPath();
          ctx.fillStyle = "#c5c5c5";
          ctx.arc(dotX, y, 3, 0, Math.PI * 2);
          ctx.fill();

          // Count text
          const countX = dotX + 12;
          ctx.fillStyle = "#2563EB"; // bright blue
          ctx.font = "700 13px";
          ctx.fillText(count, countX, y);

          ctx.restore();
        });
      });
    },
  };

  const monthlyBarChartData = {
    labels: monthListValue.map((item) => item.month),

    datasets: [
      {
        label: "",
        data: monthListValue.map((item) => item.totalCost),
        backgroundColor: "transparent",
        borderWidth: 0,
        borderSkipped: false,
      },
    ],
  };
  const monthlyBarChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    highlightIndex: activeInvIndex,

    plugins: {
      legend: { display: false },
      tooltip: { enabled: false, external: externalTooltipHandler },
    },

    interaction: { mode: "index", intersect: false },

    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#8B8B8B", font: { size: 10 } },
      },

      y: {
        beginAtZero: true,
        grid: {
          display: true,
          drawBorder: false,
          drawTicks: false,
          borderDash: [5, 5], // ← shorter dots for cleaner look
          color: "#D7DFE4",
          lineWidth: 1.2,
          setLineDash: (ctx) => (ctx.type === "grid" ? [4, 4] : []),
        },
        border: {
          display: true,
          dash: [5, 5], // ⭐ finally dotted
          color: "#D7DFE4",
          width: 1.2,
        },
        ticks: {
          color: "#6E6E6E",
          font: { size: 11 },
          callback(value) {
            return formatIndianNumber(value);
          },
        },
      },
    },
  };

  const verticalLinessPlugin = {
    id: "verticalLinessPlugin",
    afterDatasetDraw(chart, args) {
      const { ctx, chartArea } = chart;
      const highlightIndex = chart.config.options.highlightIndex;
      const meta = chart.getDatasetMeta(0);

      ctx.save();

      meta.data.forEach((bar, index) => {
        if (!bar) return;

        const x = bar.x;
        const yTop = bar.y;
        const bottom = chartArea.bottom;

        // 🌈 Color logic
        const isActive = index === highlightIndex;
        const lineColor = isActive ? "#3B84E6" : "#C8C8C8";
        const circleColor = isActive ? "#3B84E6" : "#C8C8C8";

        // vertical line
        ctx.beginPath();
        ctx.moveTo(x, yTop);
        ctx.lineTo(x, bottom);
        ctx.lineWidth = 2;
        ctx.strokeStyle = lineColor;
        ctx.stroke();

        // circle
        ctx.beginPath();
        ctx.arc(x, yTop, 8, 0, Math.PI * 2);
        ctx.fillStyle = circleColor;
        ctx.fill();

        // white stroke only for active one
        if (isActive) {
          ctx.strokeStyle = "#FFFFFF";
          ctx.lineWidth = 3;
          ctx.stroke();
        }
      });

      ctx.restore();
    },
  };

  const currentData = {
    datasets: [
      {
        data: currentValueData.map((item) => item.cost),
        backgroundColor: ["#3B84E6", "#579CF7", "#80B7FF", "#9FC9FF", "#C4DDFF"],
        borderWidth: 0,
        borderRadius: 0,
        cutout: "70%",
        rotation: -90,
        circumference: 360,
      },
    ],
  };

  const currentOptions = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      centerText: {
        value: currentValueTotal,
      },
    },
    hover: { mode: null },
  };

  const plugins = [
    {
      id: "centerText",
      afterDraw(chart) {
        const { ctx, width, height } = chart;

        const value = chart.options.plugins.centerText.value;

        ctx.save();

        // Main count text
        ctx.font = "700 32px Inter, sans-serif"; // <-- Bigger consistent font
        ctx.fillStyle = "#091E42";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(`${value}`, width / 2, height / 2 - 10);

        // Total assets label
        ctx.font = "500 14px Inter, sans-serif";
        ctx.fillStyle = "#94A3B8";
        ctx.fillText("Total assets", width / 2, height / 2 + 18);

        ctx.restore();
      },
    },
  ];

  const formatIndianNumber = (num) => {
    if (num >= 10000000) return (num / 10000000).toFixed(1).replace(/\.0$/, "") + "Cr"; // Crore
    if (num >= 100000) return (num / 100000).toFixed(1).replace(/\.0$/, "") + "L"; // Lakh
    if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K"; // Thousand
    return num.toString(); // below 1000 → show as is
  };

  const createdDateBarChartData = {
    labels: deprecitionListValue.map((item) => item.month),
    datasets: [
      {
        label: "",
        data: deprecitionListValue.map((item) => item.percentage),
        minBarLength: 20,

        backgroundColor: function (context) {
          const index = context.dataIndex;
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (index !== activeExpIndex) return "#F5F5F5";
          if (!chartArea) return null;

          // main gradient
          const gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0);
          gradient.addColorStop(0, "#2E73D5");
          gradient.addColorStop(0.5, "#5EA3FF");
          gradient.addColorStop(1, "#A4C9FF");

          // texture overlay
          const img = new Image();
          img.src = "/textures/metal-blue-texture.png";
          const texture = ctx.createPattern(img, "repeat");

          // composite texture + gradient
          ctx.save();
          ctx.globalAlpha = 0.3; // transparency control
          ctx.fillStyle = texture;
          ctx.restore();

          return gradient;
        },

        borderWidth: 0,
        borderSkipped: false,
        borderRadius: {
          topLeft: 8,
          topRight: 8,
          bottomLeft: 0,
          bottomRight: 0,
        },
        barThickness: 20,
      },
    ],
  };

  const createdDateBarChartOptions = {
    responsive: true,
    maintainAspectRatio: false,

    onClick: (event, elements) => {
      if (elements.length > 0) setActiveExpIndex(elements[0].index);
    },

    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        external: (context) => {
          const { chart, tooltip } = context;

          let tooltipEl = document.getElementById("custom-chart-tooltip");
          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "custom-chart-tooltip";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.background = "#FFFFFF";
            tooltipEl.style.borderRadius = "14px";
            tooltipEl.style.padding = "14px 18px";
            tooltipEl.style.boxShadow = "0px 4px 24px rgba(0,0,0,0.15)";
            tooltipEl.style.opacity = 0;
            tooltipEl.style.transition = "opacity 0.15s ease";
            tooltipEl.style.zIndex = 99999;
            tooltipEl.style.width = "200px"; // exact card width
            tooltipEl.style.height = "120px"; // exact card height
            document.body.appendChild(tooltipEl);
          }

          if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          const dp = tooltip.dataPoints[0];
          const index = dp.dataIndex;
          const currentMonth = monthNames[dp.label]; // convert Jan → January

          const percentage = deprecitionListValue[index].percentage; // coming from API
          const amount = deprecitionListValue[index].totalCost;

          tooltipEl.innerHTML = `
    <div style="font-size:16px;font-weight:700;color:#3B84E6;margin-bottom:8px;">
      ${percentage} %
    </div>

    <div style="font-size:18px;font-weight:700;color:#212129;margin-bottom:8px;">
      ₹${amount.toLocaleString("en-IN")}
    </div>

    <div style="font-size:14px;color:#8A8A8A;">
      ${currentMonth}, ${selectedYearMontTotal?.getFullYear()}
    </div>
  `;

          // Tooltip position
          const { left, top } = chart.canvas.getBoundingClientRect();
          tooltipEl.style.left = left + tooltip.caretX - 100 + "px";
          tooltipEl.style.top = top + tooltip.caretY - 110 + "px";
          tooltipEl.style.opacity = 1;
        },
      },
    },

    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
      },
      y: {
        beginAtZero: true,
        border: {
          display: true,
          dash: [5, 5],
          color: "#D7DFE4",
          width: 1.2,
        },
        grid: {
          display: true,
          drawBorder: false,
          drawTicks: false,
          color: "#D7DFE4",
          borderDash: [2, 4],
          lineWidth: 0.8,
        },
        ticks: {
          color: "#6E6E6E",
          font: { size: 11 },
          callback: (value) => value.toLocaleString("en-IN"),
        },
      },
    },
  };
  const [yearTotalData, setYearTotalData] = useState({
    labels: [],
    datasets: [],
  });

  const yearTotalOptions = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { left: 10, right: 100 } }, // right padding for labels
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    scales: {
      x: { display: false },
      y: {
        // offset: false,
        grid: { display: false },
        ticks: {
          color: "#172B4D",
          font: {
            size: 13,
            weight: "600",
          },
        },
      },
    },
  };
  const data = {
    labels,
    datasets: [
      {
        label: "Check in",
        data: checkInData,
        backgroundColor: "#337FE5",
        borderRadius: 4,
        barPercentage: 0.3,
      },
      {
        label: "Check out",
        data: checkOutData,
        backgroundColor: "#8BBCFF",
        borderRadius: 4,
        barPercentage: 0.3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value >= 1000 ? value / 1000 + "K" : value;
          },
        },
        grid: {
          color: "#E5E7EB",
          borderDash: [5, 5],
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "#FFFFFF",
        titleColor: "#3B84E6",
        bodyColor: "#172B4D",
        borderColor: "#EBEBEB",
        borderWidth: 1,
        cornerRadius: 6,
        displayColors: false,
        padding: 10,
        bodyFont: {
          size: 12,
          family: "Lexend Deca",
          weight: "400",
        },
        titleFont: {
          size: 14,
          family: "Lexend Deca",
          weight: "600",
        },

        callbacks: {
          title: (tooltipItems) => {
            const day = tooltipItems[0].label;
            return `${day} May 2025`;
          },
          label: (tooltipItem) => {
            const label = tooltipItem.dataset.label;
            const value = tooltipItem.raw;
            return `${label}: ${value}`;
          },
        },
      },
    },
  };

  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % employeesData.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  }, []);

  //Consumption List
  useEffect(() => {
    const { checkout, checkin, approved, report } = progressData;
    setTotal(checkout + checkin + approved + report);
  }, [progressData]);
  useEffect(() => {
    if (assetStatusData && assetStatusData.length > 0) {
      setYearTotalData({
        labels: assetStatusData.map((item) => item.status.charAt(0).toUpperCase() + item.status.slice(1)),
        datasets: [
          {
            data: assetStatusData.map((item) => item.total_depreciation),
            backgroundColor: barColors,
            borderRadius: {
              topRight: 100,
              bottomRight: 100,
              topLeft: 0,
              bottomLeft: 0,
            },
            borderSkipped: false,
            barPercentage: 1,
            categoryPercentage: 1,
            barThickness: 38,
          },
        ],
      });
    }
  }, [assetStatusData]); // runs only when assetStatusData updates

  useEffect(() => {
    getActivity(activityDate);
  }, [activityDate]);
  useEffect(() => {
    fetchProgressData(dailyprocess);
  }, [dailyprocess]);
  useEffect(() => {
    getConsumption(consumptionDate);
  }, [consumptionDate]);
  useEffect(() => {
    getYearTotalcost();
  }, [selectedYearTotal, isMonthly, selectedMonth]);
  useEffect(() => {
    monthlyTotalcost();
  }, [selectedYearMontTotal]);
  useEffect(() => {
    monthDeprecition();
  }, [selectedDeprecYear]);
  useEffect(() => {
    getEmployeeCost();
  }, [search]);
  useEffect(() => {
    getCurrentValue();
  }, []);
  useEffect(() => {
    getCounts();
  }, []);
  useEffect(() => {
    getTlusage(topdate);
  }, [topdate]);
  useEffect(() => {
    getGatelog(gatelogDate);
  }, [gatelogDate]);

  useEffect(() => {
    if (gatelog?.data?.length) {
      const labelsArr = [];
      const checkInArr = [];
      const checkOutArr = [];

      gatelog.data.forEach((item) => {
        labelsArr.push(`Day ${item.day}`);
        checkInArr.push(item.checkin);
        checkOutArr.push(item.checkout);
      });

      setLabels(labelsArr);
      setCheckInData(checkInArr);
      setCheckOutData(checkOutArr);
    } else {
      setLabels([]);
      setCheckInData([]);
      setCheckOutData([]);
    }
  }, [gatelog]);

  //Api
  const getActivity = async (period) => {
    try {
      const response = await getActivityApi({ period });
      if (response?.data?.success === true) {
        setActivity(response.data.count);
      }
    } catch (err) {
      console.error("Error fetching activity:", err);
    }
  };

  const fetchProgressData = async (date) => {
    try {
      const response = await getDailyprograssApi({ date });
      if (response?.data?.success === true) {
        setProgressData(response.data.count || {});
        console.log("Progress for", date, ":", response.data.count);
      }
    } catch (err) {
      console.error("Error fetching progress data:", err);
    }
  };
  const getCounts = async () => {
    try {
      const response = await getCountsApi();
      if (response?.data?.success === true) {
        setcounts(response.data.count);
        // console.log(response);
      }
      return response?.data?.count;
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const getConsumption = async (from_date) => {
    try {
      let params = {};

      if (from_date) {
        const date = new Date(from_date);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;

        const paddedMonth = String(month).padStart(2, "0");
        const lastDay = new Date(year, month, 0).getDate();

        params.from_date = `${year}-${paddedMonth}-01`;
        params.to_date = `${year}-${paddedMonth}-${lastDay}`;
      }

      const response = await getConsumptionApi(params);

      if (response?.data?.success === true) {
        setConsumption(response.data.entries);
      }
    } catch (err) {
      console.error("Error fetching activity:", err);
    }
  };
  const getYearTotalcost = async () => {
    try {
      const params = {
        year: selectedYearTotal?.getFullYear(),
        is_month: isMonthly,
        month: selectedMonth?.getMonth() + 1,
      };

      const response = await getyearTotalApi(params);

      if (response?.data?.success === true) {
        setAssetStatusData([]);
        setAssetStatusData(response?.data?.data ?? []);
      }
    } catch (err) {
      console.error("Error fetching activity:", err);
    }
  };
  const monthlyTotalcost = async () => {
    try {
      const params = {
        year: selectedYearMontTotal?.getFullYear(),
      };

      const response = await getMonthTotalApi(params);

      if (response?.data?.success === true) {
        setMonthListValue(response?.data?.data ?? []);
      }
      // console.log(response.data);
    } catch (err) {
      console.error("Error fetching activity:", err);
    }
  };
  const monthDeprecition = async () => {
    try {
      const params = {
        year: selectedDeprecYear?.getFullYear(),
      };

      const response = await getDeprecitTotalApi(params);

      if (response?.data?.success === true) {
        setdeprictionListValue(response?.data?.data ?? []);
      }
      // console.log(response.data);
    } catch (err) {
      console.error("Error fetching activity:", err);
    }
  };
  const getEmployeeCost = async () => {
    try {
      const params = {
        search: search,
        limit: itemsPerPage,
        skip: itemOffset,
      };

      const response = await getEmployeeApi(params);

      if (response?.data?.success === true) {
        setEmployeesData(response?.data?.data ?? []);
        setEmployeeCount(response.data.total_rec);
        setPageCount(response.data.total_pgs);
      }
      // console.log(response.data);
    } catch (err) {
      console.error("Error fetching activity:", err);
    }
  };

  const getCurrentValue = async () => {
    try {
      const response = await getCurrentValueApi();

      if (response?.data?.success === true) {
        const formattedStatus = (response?.data?.data.status ?? []).map((item, index) => ({
          ...item,
          label: item.status.charAt(0).toUpperCase() + item.status.slice(1),
          amount: `₹${item.cost.toLocaleString("en-IN")}`,
          color: barColors[index] || "#000", // fallback
          count: item.count, // fallback
        }));

        setCurrentValueData(formattedStatus);

        setCurrentValueTotal(response?.data?.data.total_assets ?? 0);
        setTimeout(() => {
          chartRef.current?.update();
        }, 50);
      }
      // console.log(response.data);
    } catch (err) {
      console.error("Error fetching activity:", err);
    }
  };

  //Top & Least usage

  const getTlusage = async (period) => {
    try {
      const response = await getTlusageApi({ period });
      if (response?.data?.success === true) {
        setTlusage(response.data);
      }
      // console.log(response.data);
    } catch (err) {
      console.error("Error fetching activity:", err);
    }
  };

  const getGatelog = async (period) => {
    try {
      const response = await getGatelogApi({ period });
      if (response?.data?.success === true && Array.isArray(response.data.data) && response.data.data.length > 0) {
        setGatelog(response.data);
        console.log(response.data);
      } else {
        setGatelog({});
        setLabels([]);
        setCheckInData([]);
        setCheckOutData([]);
      }
    } catch (err) {
      setGatelog({});
      setLabels([]);
      setCheckInData([]);
      setCheckOutData([]);
      console.error("Error fetching activity:", err);
    }
  };

  return (
    <div
      style={{
        fontFamily: "Lexend Deca",
        backgroundColor: "#F5F8FA",
        borderRadius: "12px",
        width: "100%",
        padding: 20,
        marginTop: "10px",
      }}
    >
      {/* HEADERl */}
      <Row>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontWeight: 600,
              color: "#3B84E6",
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img src={Overview} alt="Overview" style={{ width: 24, height: 24, marginRight: 10 }} />
            Analytics overview
          </div>{" "}
          {/* <div style={{ display: "flex", gap: "10px" }}>
            
            <Button
              style={{
                marginRight: "10px",
                padding: "14px 16px",
                backgroundColor: "#FFFFFF",
                color: "#3B84E6",
                border: "1px solid #3B84E6",
                display: "flex",
                alignItems: "center",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                position: "relative",
                gap: "6px",
              }}
              onClick={() => {
                document
                  .getElementById("dashboardFilterDateInput")
                  .showPicker?.() ||
                  document.getElementById("dashboardFilterDateInput").focus();
              }}
            >
              <img
                src={Calander}
                alt="Calendar"
                style={{ width: 16, height: 16 }}
              />

              <input
                id="dashboardFilterDateInput"
                type="date"
                value={dailyprocess}
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  setfilterValue(selectedDate);
                  const selectedMonth = selectedDate.slice(0, 7);
                  setActivitydate(selectedMonth);
                  setGatelogdate(selectedMonth);
                  setTopdate(selectedMonth);
                  setConsumptiondate(selectedMonth);
                  setDailyprocess(selectedDate);
                }}
                style={{
                  position: "absolute",
                  opacity: 0,
                  pointerEvents: "none",
                  width: 0,
                  height: 0,
                }}
                tabIndex={-1}
                readOnly={false}
              />

              <span style={{ whiteSpace: "nowrap" }}>
                {filtervalue === "" ? "Filter by date range" : filtervalue}
              </span>

              {filtervalue !== "" && (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    const now = new Date();
                    const currentDate = `${now.getFullYear()}-${String(
                      now.getMonth() + 1
                    ).padStart(2, "0")}-${String(now.getDate()).padStart(
                      2,
                      "0"
                    )}`;
                    const fullDateStr = now.toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    });

                    const monthYearStr = now.toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                    });
                    setDailyprocess(fullDateStr);
                    setActivitydate(monthYearStr);
                    setfilterValue("");
                    setGatelogdate(monthYearStr);
                    setTopdate(monthYearStr);
                    setConsumptiondate(monthYearStr);
                  }}
                  style={{
                    marginLeft: "auto",
                    color: "#999",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                  title="Clear"
                >
                  ×
                </span>
              )}
            </Button>

            <Button
              style={{
                marginRight: "10px",
                padding: "14px",
                backgroundColor: "#3B84E6",
                color: "#FFFFFF",
                border: "1px solid #3B84E6",
                display: "flex",
                alignItems: "center",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              <img
                src={Download}
                alt="Download"
                style={{ width: 16, height: 16, marginRight: 6 }}
              />
              Download report
            </Button>
          </div> */}
        </div>
      </Row>

      {/* CONTENT */}
      <div style={{ gap: "10px" }}>
        <div
          style={{
            fontSize: 16,
            fontWeight: 400,
            color: "#172B4D",
            marginBottom: "10px",
          }}
        >
          Assets overview
        </div>

        <Row className="m-0 mb-3" style={{ display: "flex", gap: "10px" }}>
          <Col
            md={12}
            lg={6}
            style={{
              backgroundColor: "#FFFFFF",
              padding: "10px",
              borderRadius: 16,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "0px 3px 6px 0px #00000014",
            }}
          >
            <div
              style={{
                flex: 1,
                borderRight: "1px solid #E5E7EB",
                paddingRight: 16,
              }}
            >
              <div style={{ fontSize: "14px", color: "#8790A1" }}>Total assets</div>
              <div style={{ fontSize: "32px", fontWeight: 500, color: "#172B4D" }}>{counts?.total?.count ?? 0}</div>
              <div style={{ fontSize: "14px", fontWeight: 400, color: "#172B4D" }}>
                <span
                  style={{
                    fontSize: "16px",
                    color: "#4BC072",
                    fontWeight: "600",
                  }}
                >
                  {counts?.total?.percent ?? 0}%
                </span>{" "}
                more than last month
              </div>
            </div>
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "space-around",
                gap: "10px",
                marginLeft: "10px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#F8F8F8",
                  padding: "12px 16px",
                  borderRadius: 16,
                  width: "100%",
                }}
              >
                <div
                  style={{
                    fontSize: "13px",
                    color: "#4BC072",
                    fontWeight: 500,
                  }}
                >
                  Allocated
                </div>
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: 500,
                    color: "#172B4D",
                  }}
                >
                  {counts?.allocated?.count ?? 0}
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#F8F8F8",
                  padding: "12px 16px",
                  borderRadius: 16,
                  width: "100%",
                }}
              >
                <div
                  style={{
                    fontSize: "13px",
                    color: "#FF4444",
                    fontWeight: 500,
                  }}
                >
                  Non-Allocated
                </div>
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: 500,
                    color: "#172B4D",
                  }}
                >
                  {counts?.nonallocated?.count ?? 0}
                </div>
              </div>
            </div>
          </Col>

          <Col
            style={{
              flex: "1",
              backgroundColor: "#FFFFFF",
              padding: 16,
              borderRadius: 16,
              boxShadow: "0px 3px 6px 0px #00000014",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div style={{ fontSize: "14px", color: "#8790A1" }}>Missing</div>
            <div style={{ fontSize: "32px", fontWeight: 500, color: "#172B4D" }}>{counts?.missing?.count ?? 0}</div>
            <div style={{ fontSize: "14px", fontWeight: 400, color: "#172B4D" }}>
              <span style={{ fontSize: "16px", color: "#4BC072", fontWeight: 600 }}>{counts?.missing?.percent ?? 0}%</span> more than last month
            </div>
          </Col>
          <Col
            style={{
              flex: "1",
              backgroundColor: "#FFFFFF",
              padding: 16,
              borderRadius: 16,
              boxShadow: "0px 3px 6px 0px #00000014",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div style={{ fontSize: "14px", color: "#8790A1" }}>Repair</div>
            <div style={{ fontSize: "32px", fontWeight: 500, color: "#172B4D" }}>{counts?.repair?.count ?? 0}</div>
            <div style={{ fontSize: "14px", fontWeight: 400, color: "#172B4D" }}>
              <span style={{ fontSize: "16px", color: "#4BC072", fontWeight: 600 }}>{counts?.repair?.percent ?? 0}%</span> more than last month
            </div>
          </Col>
          <Col
            style={{
              flex: "1",
              backgroundColor: "#FFFFFF",
              padding: 16,
              borderRadius: 16,
              boxShadow: "0px 3px 6px 0px #00000014",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div style={{ fontSize: "14px", color: "#8790A1" }}>Scrap</div>
            <div style={{ fontSize: "32px", fontWeight: 500, color: "#172B4D" }}>{counts?.scrab?.count ?? 0}</div>
            <div style={{ fontSize: "14px", fontWeight: 400, color: "#172B4D" }}>
              <span style={{ fontSize: "16px", color: "#4BC072", fontWeight: 600 }}>{counts?.scrab?.percent ?? 0}%</span> more than last month
            </div>
          </Col>
        </Row>
      </div>

      <Row className="m-0 mb-3" style={{ display: "flex", flexWrap: "nowrap", gap: "10px" }}>
        {assetStatusData.length > 0 && (
          <Col
            xs={12}
            md={6}
            style={{
              flex: "2",
              padding: "15px",
              backgroundColor: "#FFFFFF",
              boxShadow: "0px 3px 6px 0px #00000014",
              borderRadius: "16px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div className="project-card">
              <div className="d-flex justify-content-between align-items-center ">
                <span className="fs-16 fw-600 textcolor" style={{ paddingLeft: "12px" }}>
                  Year Total cost
                </span>

                <div className="toggle-wrapper">
                  <span className={`fs-12 fw-600 label ${!isMonthly ? "active" : ""}`}>Yearly</span>
                  <div className={`toggle-switch ${isMonthly ? "monthly" : "yearly"}`} onClick={() => setIsMonthly(!isMonthly)}>
                    <div className="toggle-circle"></div>
                  </div>
                  <span className={`label ${isMonthly ? "active" : ""}`}>Monthly</span>
                </div>
                <div className="year-picker-btn d-flex">
                  {isMonthly ? (
                    <MonthPicker selectedMonth={selectedMonth} setSelectedMonth={setSelectedMonth} />
                  ) : (
                    <div
                      style={{
                        width: "100px",

                        height: "12px",
                      }}
                    />
                  )}

                  <YearPicker selectedYear={selectedYearTotal} setSelectedYear={setSelectedYearTotal} />
                </div>
              </div>

              <div style={{ height: "300px", width: "100%", marginTop: "16px" }}>
                {yearTotalData?.datasets?.[0]?.data?.length > 0 ? (
                  <Bar data={yearTotalData} options={yearTotalOptions} plugins={[barValuePlugin]} />
                ) : (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#999",
                      fontSize: "16px",
                      fontWeight: 500,
                      borderRadius: "8px",
                    }}
                  >
                    No data found
                  </div>
                )}
              </div>
            </div>
          </Col>
        )}
        {monthListValue.length > 0 && (
          <Col
            xs={12}
            md={6}
            style={{
              flex: "2",
              padding: "15px",
              backgroundColor: "#FFFFFF",
              boxShadow: "0px 3px 6px 0px #00000014",
              borderRadius: "16px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div className="project-card">
              <div className="d-flex justify-content-between align-items-center ">
                <span className="fs-16 fw-600 textcolor" style={{ paddingLeft: "12px"}}>
                  Monthly Total cost
                </span>
                <YearPicker selectedYear={selectedYearMontTotal} setSelectedYear={setSelectedYearMontTotal} />
              </div>

              <div style={{ height: "283px", width: "100%", marginTop: "16px", overflowX: "auto"}}>
                <div style={{ height: "100%", width: monthListValue.length > 10 ? `${monthListValue.length * 60}px` : "100%" }}>
                  <Bar data={monthlyBarChartData} options={monthlyBarChartOptions} plugins={[verticalLinessPlugin]} />
                </div>
              </div>
            </div>
          </Col>
        )}
      </Row>
      <Row className="m-0 mb-3" style={{ gap: "10px" }}>
        {currentValueData.length > 0 && (
          <Col
            xs={12}
            md={6}
            style={{
              flex: "2",
              padding: "15px",
              backgroundColor: "#FFFFFF",
              boxShadow: "0px 3px 6px 0px #00000014",
              borderRadius: "16px",
            }}
          >
            <div className="project-card">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fs-16 fw-600 textcolor" style={{ paddingLeft: "12px" }}>
                  Current value
                </span>
              </div>

              <div
                className="mt-4"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    width: "190px",
                    height: "190px",
                    position: "relative",
                  }}
                >
                  <Doughnut ref={chartRef} data={currentData} options={currentOptions} plugins={plugins} />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: "14px",
                  }}
                >
                  {currentValueData.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "310px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            width: "10px",
                            height: "10px",
                            backgroundColor: item.color,
                            borderRadius: "50%",
                          }}
                        ></div>
                        <span
                          style={{
                            color: "#4A4A4A",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {item.label}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <span
                          style={{
                            color: "#0F233F",
                            fontSize: "14px",
                            fontWeight: 600,
                          }}
                        >
                          {item.amount}
                        </span>

                        <span
                          style={{
                            width: "4px",
                            height: "4px",
                            background: "#D9D9D9",
                            borderRadius: "50%",
                            display: "inline-block",
                          }}
                        ></span>

                        <span
                          style={{
                            color: "#3B84E6",
                            fontSize: "14px",
                            fontWeight: 600,
                          }}
                        >
                          {item.count}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Col>
        )}
        {deprecitionListValue.length > 0 && (
          <Col
            xs={12}
            md={6}
            style={{
              flex: "2",
              padding: "15px",
              backgroundColor: "#FFFFFF",
              boxShadow: "0px 3px 6px 0px #00000014",
              borderRadius: "16px",
            }}
          >
            <div className="project-card">
              <div className="d-flex justify-content-between align-items-center w-100">
                <span className="fs-16 fw-600 textcolor" style={{ paddingLeft: "12px" }}>
                  Depreciation per year
                </span>
                <YearPicker selectedYear={selectedDeprecYear} setSelectedYear={setSelectedDeprecYear} />
              </div>

              <div style={{ height: "223px", width: "100%", marginTop: "16px", overflowX: "auto" }}>
                <div style={{ height: "100%", width: deprecitionListValue.length > 10 ? `${deprecitionListValue.length * 60}px` : "100%" }}>
                  <Bar data={createdDateBarChartData} options={createdDateBarChartOptions} />
                </div>
              </div>
            </div>
          </Col>
        )}
      </Row>
      {employeesData.length > 0 && (
        <div className="mb-3" style={{ padding: "24px", background: "#fff", borderRadius: "16px" }}>
          {/* Header with Search */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div
              style={{
                color: "#212129",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Employee wise total amount & Per day cost
            </div>

            <div
              style={{
                width: "280px",
                border: "1px solid #E5E5E5",
                borderRadius: "50px",
                padding: "6px 14px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "#FFFFFF",
              }}
            >
              <SearchIc />
              <input
                placeholder="Search"
                style={{
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#66737E",
                }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          {/* Cards Grid */}
          {
            <div
              style={{
                maxHeight: "500px", // Adjust height as needed
                overflowY: "auto",
                paddingRight: "6px", // optional to avoid scrollbar hiding content
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: "16px",
                }}
              >
                {employeesData.map((emp) => (
                  <div
                    key={emp.id}
                    style={{
                      backgroundColor: "#F9F9F9",
                      borderRadius: "24px",
                      padding: "12px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      cursor: "pointer",
                      height: "149px",
                    }}
                  >
                    {/* Card Header */}
                    <div className="d-flex align-items-center gap-3">
                      <div
                        style={{
                          width: "52px",
                          height: "52px",
                          borderRadius: "12px",
                          background: "#FFFFFF",
                        }}
                      >
                        <DefaultProIc />
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#172B4D",
                          }}
                        >
                          {emp.employee_name}
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#8790A1",
                          }}
                        >
                          {emp.email}
                        </div>
                      </div>
                    </div>

                    {/* Values Section */}
                    <div className="d-flex gap-3">
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: "10px",
                          padding: "10px 14px",
                          flex: 1,
                          textAlign: "center",
                          height: "61px",
                          border: "1px solid #EBEBEB",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#172B4D",
                          }}
                        >
                          ₹ {emp.asset_value ?? 0}
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#8790A1",
                          }}
                        >
                          Asset value
                        </div>
                      </div>

                      <div
                        style={{
                          background: "#fff",
                          borderRadius: "10px",
                          padding: "10px 14px",
                          flex: 1,
                          textAlign: "center",
                          height: "61px",
                          border: "1px solid #EBEBEB",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#172B4D",
                          }}
                        >
                          ₹ {emp.per_day_cost ?? 0}
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#8790A1",
                          }}
                        >
                          Per day cost
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          }

          {/* Pagination */}
          <div className="d-flex justify-content-center mt-4">
            <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
          </div>
        </div>
      )}
      {/* content 2 */}
      <Row className="m-0" style={{ gap: "10px" }}>
        <Col
          sm={12}
          lg={3}
          style={{
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 3px 6px 0px #00000014",
            borderRadius: "16px",
            padding: "16px",
          }}
        >
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontWeight: 700, fontSize: "16px", color: "#172B4D" }}>Daily Progress</p>
            <span
              style={{
                fontSize: "13px",
                color: "#3B84E6",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
                marginTop: "-15px",
              }}
            >
              <img src={Calander} alt="icon" width={14} style={{ marginRight: "4px", cursor: "pointer" }} onClick={() => document.getElementById("date").showPicker()} />
              <input
                id="date"
                type="date"
                value={dailyprocess}
                onChange={(e) => {
                  const selecteddate = e.target.value;
                  setDailyprocess(selecteddate);
                }}
                style={{
                  position: "absolute",
                  opacity: 0,
                  pointerEvents: "none",
                }}
              />
              {new Date(dailyprocess).toLocaleString("en-US", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>

          {/* Progress Bar (Dynamic width) */}
          <div
            style={{
              display: "flex",
              gap: "4px",
              marginBottom: "12px",
              borderRadius: "5px",
              overflow: "hidden",
              height: "12px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <div
              style={{
                width: `${total > 0 ? (checkout / total) * 100 : 0}%`,
                backgroundColor: "#84B4F5",
              }}
            ></div>
            <div
              style={{
                width: `${total > 0 ? (checkin / total) * 100 : 0}%`,
                backgroundColor: "#FDA48E",
              }}
            ></div>
            <div
              style={{
                width: `${total > 0 ? (approved / total) * 100 : 0}%`,
                backgroundColor: "#8AAA99",
              }}
            ></div>
            <div
              style={{
                width: `${total > 0 ? (report / total) * 100 : 0}%`,
                backgroundColor: "#FF8989",
              }}
            ></div>
          </div>

          {/* Labels */}
          {[
            { label: "Check Out", value: checkout, color: "#84B4F5" },
            { label: "Check In", value: checkin, color: "#FDA48E" },
            { label: "Approved", value: approved, color: "#8AAA99" },
            { label: "Report", value: report, color: "#FF8989" },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "6px",
                padding: "8px 12px",
                borderRadius: "16px",
                backgroundColor: "#F8F8F8",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: item.color,
                    display: "inline-block",
                    marginRight: "8px",
                  }}
                ></span>
                <span>{item.label}</span>
              </div>
              <span>{item.value}</span>
            </div>
          ))}
        </Col>
        <Col
          sm={12}
          lg={8}
          style={{
            flex: "2",
            padding: "15px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 3px 6px 0px #00000014",
            borderRadius: "16px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ fontWeight: 700, fontSize: "16px", color: "#172B4D" }}>Activities in Assets </p>
            <span
              style={{
                fontSize: "13px",
                color: "#3B84E6",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img src={Calander} alt="icon" width={14} style={{ marginRight: "4px", cursor: "pointer" }} onClick={() => document.getElementById("monthInput").showPicker()} />
              <input
                id="monthInput"
                type="month"
                value={activityDate}
                onChange={(e) => {
                  const selectedPeriod = e.target.value;
                  setActivitydate(selectedPeriod);
                }}
                style={{
                  position: "absolute",
                  opacity: 0,
                  pointerEvents: "none",
                }}
              />
              {new Date(activityDate).toLocaleString("en-US", {
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>
          <Col lg={3}>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ fontSize: "32px", fontWeight: 400, color: "#172B4D" }}>{activity?.total?.count ?? 0}</div>
              <div style={{ fontSize: "14px", fontFamily: 400, color: "#626F86" }}>
                <span
                  style={{
                    fontSize: "14px",
                    fontFamily: 600,
                    color: "#4BC072",
                  }}
                >
                  {activity?.total?.percent ?? 0}%
                </span>{" "}
                more than last month
              </div>
            </div>
          </Col>
          {/* ADDED */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              overflowX: "auto",
            }}
          >
            <div style={{ width: "100%", minWidth: "200px" }}>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              ></Row>
              <Col
                style={{
                  backgroundColor: "#EFECE7",
                  borderRadius: "16px",
                  padding: "10px",
                  border: "none",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <Row>
                  <Col xs={9} style={{ gap: "10px", paddingRight: 0 }}>
                    <div
                      style={{
                        color: "#172B4D",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginBottom: "25px",
                      }}
                    >
                      Added
                    </div>
                    <div
                      style={{
                        fontSize: "32px",
                        color: "#172B4D",
                        fontWeight: 600,
                      }}
                    >
                      {" "}
                      {activity?.added?.count ?? 0}{" "}
                    </div>{" "}
                    {/* value */}
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#172B4D",
                        fontWeight: 400,
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>{activity?.added?.percent ?? 0}%</span> more than
                      <br /> last month
                    </div>
                  </Col>

                  <Col
                    xs={3}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        height: "130px",
                        width: "16px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "999px",
                        position: "relative",
                        display: "flex",
                        alignItems: "flex-end",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: `${activity?.added?.percent ?? 0}%`,
                          backgroundColor: "#A69A87",
                          borderRadius: "999px 999px 0 0",
                          transition: "height 0.5s ease-in-out",
                        }}
                      ></div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </div>
            {/* MISSING */}
            <div style={{ width: "100%", minWidth: "200px" }}>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              ></Row>
              <Col
                style={{
                  backgroundColor: "#FFF0C8",
                  borderRadius: "16px",
                  padding: "10px",
                  border: "none",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <Row>
                  <Col xs={9} style={{ gap: "10px", paddingRight: 0 }}>
                    <div
                      style={{
                        color: "#172B4D",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginBottom: "25px",
                      }}
                    >
                      Missing
                    </div>
                    <div
                      style={{
                        fontSize: "32px",
                        color: "#172B4D",
                        fontWeight: 600,
                      }}
                    >
                      {activity?.missing?.count ?? 0}
                    </div>{" "}
                    {/* value */}
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#172B4D",
                        fontWeight: 400,
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>{activity?.missing?.percent ?? 0}%</span> more than
                      <br /> last month
                    </div>
                  </Col>

                  <Col
                    xs={3}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        height: "130px",
                        width: "16px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "999px",
                        position: "relative",
                        display: "flex",
                        alignItems: "flex-end",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: `${activity?.missing?.percent ?? 0}%`,
                          backgroundColor: "#F0CA69",
                          borderRadius: "999px 999px 0 0",
                          transition: "height 0.5s ease-in-out",
                        }}
                      ></div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </div>
            {/* REPAIR */}
            <div style={{ width: "100%", minWidth: "200px" }}>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              ></Row>
              <Col
                style={{
                  backgroundColor: "#FFE8F9",
                  borderRadius: "16px",
                  padding: "10px",
                  border: "none",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <Row>
                  <Col xs={9} style={{ gap: "10px", paddingRight: 0 }}>
                    <div
                      style={{
                        color: "#172B4D",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginBottom: "25px",
                      }}
                    >
                      Repair
                    </div>
                    <div
                      style={{
                        fontSize: "32px",
                        color: "#172B4D",
                        fontWeight: 600,
                      }}
                    >
                      {activity?.repair?.count ?? 0}
                    </div>{" "}
                    {/* value */}
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#172B4D",
                        fontWeight: 400,
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>{activity?.repair?.percent ?? 0}%</span> more than
                      <br /> last month
                    </div>
                  </Col>

                  <Col
                    xs={3}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        height: "130px",
                        width: "16px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "999px",
                        position: "relative",
                        display: "flex",
                        alignItems: "flex-end",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: `${activity?.repair?.percent ?? 0}%`,
                          backgroundColor: "#DF9DCD",
                          borderRadius: "999px 999px 0 0",
                          transition: "height 0.5s ease-in-out",
                        }}
                      ></div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </div>
            {/* SCRAP */}
            <div style={{ width: "100%", minWidth: "200px" }}>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              ></Row>
              <Col
                style={{
                  backgroundColor: "#CAF5D0",
                  borderRadius: "16px",
                  padding: "10px",
                  border: "none",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <Row>
                  <Col xs={9} style={{ gap: "10px", paddingRight: 0 }}>
                    <div
                      style={{
                        color: "#172B4D",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginBottom: "25px",
                      }}
                    >
                      Scrab
                    </div>
                    <div
                      style={{
                        fontSize: "32px",
                        color: "#172B4D",
                        fontWeight: 600,
                      }}
                    >
                      {activity?.scrab?.count ?? 0}
                    </div>{" "}
                    {/* value */}
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#172B4D",
                        fontWeight: 400,
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>{activity?.scrab?.percent ?? 0}%</span> more than
                      <br /> last month
                    </div>
                  </Col>

                  <Col
                    xs={3}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        height: "130px",
                        width: "16px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "999px",
                        position: "relative",
                        display: "flex",
                        alignItems: "flex-end",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: `${activity?.scrab?.percent ?? 0}%`,
                          backgroundColor: "#6EB579",
                          borderRadius: "999px 999px 0 0",
                          transition: "height 0.5s ease-in-out",
                        }}
                      ></div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </div>
            {/* ALLOCATED */}
            <div style={{ width: "100%", minWidth: "200px" }}>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              ></Row>
              <Col
                style={{
                  backgroundColor: "#D7E8FF",
                  borderRadius: "16px",
                  padding: "10px",
                  border: "none",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <Row>
                  <Col xs={9} style={{ gap: "10px", paddingRight: 0 }}>
                    <div
                      style={{
                        color: "#172B4D",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginBottom: "25px",
                      }}
                    >
                      Allocated
                    </div>
                    <div
                      style={{
                        fontSize: "32px",
                        color: "#172B4D",
                        fontWeight: 600,
                      }}
                    >
                      {activity?.allocated?.count ?? 0}
                    </div>{" "}
                    {/* value */}
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#172B4D",
                        fontWeight: 400,
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>{activity?.allocated?.percent ?? 0}%</span> more than
                      <br /> last month
                    </div>
                  </Col>

                  <Col
                    xs={3}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        height: "130px",
                        width: "16px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "999px",
                        position: "relative",
                        display: "flex",
                        alignItems: "flex-end",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: `${activity?.allocated?.percent ?? 0}%`,
                          backgroundColor: "#89ADDE",
                          borderRadius: "999px 999px 0 0",
                          transition: "height 0.5s ease-in-out",
                        }}
                      ></div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </div>
          </div>
        </Col>
      </Row>

      {/* chart */}
      <Row className="m-0 mt-3" style={{ gap: "10px" }}>
        <Col
          lg={7}
          style={{
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 3px 6px 0px #00000014",
            borderRadius: "16px",
            padding: "16px",
          }}
        >
          {/* Progress Bar (Dynamic width) */}
          <div className="d-flex justify-content-between">
            <div style={{ fontWeight: 700, fontSize: "16px", color: "#172B4D" }}>Gate Log Activities</div>
            <span
              style={{
                fontSize: "13px",
                color: "#3B84E6",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img src={Calander} alt="icon" width={14} style={{ marginRight: "4px", cursor: "pointer" }} onClick={() => document.getElementById("glmonthInput").showPicker()} />
              <input
                id="glmonthInput"
                type="month"
                value={gatelogDate}
                onChange={(e) => {
                  const selectedPeriod = e.target.value;
                  setGatelogdate(selectedPeriod);
                }}
                style={{
                  position: "absolute",
                  opacity: 0,
                  pointerEvents: "none",
                }}
              />
              {new Date(gatelogDate + "-01").toLocaleString("en-US", {
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>
          <div style={{ height: "250px" }}>
            <Bar data={data} options={options} />
          </div>
        </Col>

        <Col
          lg={3}
          style={{
            flex: "2",
            padding: "15px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 3px 6px 0px #00000014",
            borderRadius: "16px",
          }}
        >
          <div className="d-flex justify-content-between">
            <div style={{ fontWeight: 700, fontSize: "16px", color: "#172B4D" }}>Consumption</div>
            <span
              style={{
                fontSize: "13px",
                color: "#3B84E6",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img src={Calander} alt="icon" width={14} style={{ marginRight: "4px", cursor: "pointer" }} onClick={() => document.getElementById("conmonthInput").showPicker()} />
              <input
                id="conmonthInput"
                type="month"
                value={consumptionDate}
                onChange={(e) => {
                  const selectedPeriod = e.target.value;
                  setConsumptiondate(selectedPeriod);
                }}
                style={{
                  position: "absolute",
                  opacity: 0,
                  pointerEvents: "none",
                }}
              />
              {new Date(consumptionDate + "-01").toLocaleString("en-US", {
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>
          <div style={{ height: "250px", marginTop: "20px", overflowY: "auto" }}>
            {consumption.length > 0 ? (
              consumption.map((entries, index) => {
                const percentage = totalReading > 0 ? (entries.reading / totalReading) * 100 : 0;

                return (
                  <div
                    key={index}
                    style={{
                      padding: "12px",
                      borderRadius: "16px",
                      border: "1px solid #E5E7EB",
                      marginBottom: "12px",
                    }}
                  >
                    <Card.Body className="py-1">
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            backgroundColor: "#f0f6ff",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "18px",
                            color: "#2b6cb0",
                          }}
                        >
                          <img src={Meter} alt="Meter Icon" width={24} />
                        </div>
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: 700,
                            color: "#172B4D",
                            margin: 0,
                            textTransform: "capitalize",
                          }}
                        >
                          {entries.name}
                        </p>
                      </div>

                      <div
                        style={{
                          height: "6px",
                          borderRadius: "10px",
                          backgroundColor: "#f1f5f9",
                          width: "100%",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${percentage}%`,
                            backgroundColor: "#4299e1",
                            borderRadius: "10px",
                            transition: "width 0.3s ease",
                          }}
                        ></div>
                      </div>

                      <div className="d-flex justify-content-between mt-2">
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#172B4D",
                          }}
                        >
                          {entries.reading}
                        </span>
                        <span
                          style={{
                            fontSize: "13px",
                            color: "#8790A1",
                            fontWeight: 400,
                          }}
                        >
                          {new Date(consumptionDate + "-01").toLocaleString("en-US", { month: "long", year: "numeric" })}
                        </span>
                      </div>
                    </Card.Body>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "20px",
                  color: "#8790A1",
                  fontSize: "14px",
                }}
              >
                No data found
              </div>
            )}
          </div>
        </Col>
      </Row>

      {/* Overview */}
      <Row className="m-0 p-0">
        <Col
          lg={12}
          style={{
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 3px 6px 0px #00000014",
            borderRadius: "16px",
            padding: "16px",
            marginTop: "20px",
          }}
        >
          <div className="d-flex justify-content-between">
            <div style={{ fontWeight: 700, fontSize: "16px", color: "#172B4D" }}>Top & Least Usage Overview</div>
            <span
              style={{
                fontSize: "13px",
                color: "#3B84E6",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img src={Calander} alt="icon" width={14} style={{ marginRight: "4px", cursor: "pointer" }} onClick={() => document.getElementById("tlmonthInput").showPicker()} />
              <input
                id="tlmonthInput"
                type="month"
                value={topdate}
                onChange={(e) => {
                  const selectedPeriod = e.target.value;
                  setTopdate(selectedPeriod);
                }}
                style={{
                  position: "absolute",
                  opacity: 0,
                  pointerEvents: "none",
                }}
              />
              {new Date(topdate + "-01").toLocaleString("en-US", {
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>

          <div
            className="my-2"
            style={{
              fontSize: "15px",
              color: "#172B4D",
              marginTop: "10px",
              fontWeight: 600,
            }}
          >
            Top 5 usage
          </div>

          <div className="d-flex" style={{ gap: "12px", overflowX: "auto" }}>
            {(tlusage?.top || []).map((item, i) => {
              const total = item.total || item.days?.reduce((sum, day) => sum + parseInt(day.total || 0), 0);
              return (
                <div
                  key={i}
                  style={{
                    backgroundColor: "#E4FFE8",
                    borderRadius: "16px",
                    padding: "16px 20px",
                    minWidth: "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        color: "#172B4D",
                        margin: 0,
                        fontSize: "14px",
                        fontWeight: 400,
                      }}
                    >
                      {item.name}
                    </div>
                    <div
                      style={{
                        fontWeight: 600,
                        color: "#172B4D",
                        fontSize: "28px",
                      }}
                    >
                      {Number(total).toLocaleString()} <span style={{ fontWeight: 600, fontSize: "20px" }}>KWh</span>
                    </div>
                  </div>
                  <div className="d-flex align-items-end gap-1" style={{ height: "100%" }}>
                    {(item.days || []).map((day, index) => {
                      const height = Math.min(100, parseInt(day.total || 0));
                      return (
                        <div
                          key={index}
                          style={{
                            width: "4px",
                            height: "60px",
                            backgroundColor: "#FFFFFF",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "flex-end",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              width: "4px",
                              height: `${height}%`,
                              backgroundColor: "#6EB579",
                              borderRadius: "1100px",
                            }}
                          ></div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>

          <div
            className="my-2"
            style={{
              fontSize: "15px",
              color: "#172B4D",
              marginTop: "10px",
              fontWeight: 600,
            }}
          >
            Top 5 least usage
          </div>

          <div className="d-flex" style={{ gap: "12px", overflowX: "auto" }}>
            {(tlusage?.least || []).length === 0 ? (
              <div style={{ fontSize: "14px", color: "#6B7280" }}>No data available</div>
            ) : (
              tlusage.least.map((item, i) => {
                const total = item.total || item.days?.reduce((sum, day) => sum + parseInt(day.total || 0), 0);
                return (
                  <div
                    key={i}
                    style={{
                      backgroundColor: "#FFEAEA",
                      borderRadius: "16px",
                      padding: "16px 20px",
                      minWidth: "200px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          color: "#172B4D",
                          margin: 0,
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                      >
                        {item.name}
                      </div>
                      <div
                        style={{
                          fontWeight: 600,
                          color: "#172B4D",
                          fontSize: "28px",
                        }}
                      >
                        {Number(total).toLocaleString()} <span style={{ fontWeight: 600, fontSize: "20px" }}>KWh</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-end gap-1" style={{ height: "100%" }}>
                      {(item.days || []).map((day, index) => {
                        const height = Math.min(100, parseInt(day.total || 0));
                        return (
                          <div
                            key={index}
                            style={{
                              width: "4px",
                              height: "60px",
                              backgroundColor: "#FFFFFF",
                              borderRadius: "4px",
                              display: "flex",
                              alignItems: "flex-end",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "4px",
                                height: `${height}%`,
                                backgroundColor: "#FF4444",
                                borderRadius: "1100px",
                              }}
                            ></div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
